<template>
  <b-container>
    <b-table :fields="fields" :items="stats" show-empty> </b-table>
  </b-container>
</template>

<script>
export default {
  name: "playerLastSeason",
  props: ["stats", "config"],
  data() {
    return {
      fields: [
        { key: "DATE", label: "Date" },
        { key: "NAME", label: "Name" },
        { key: "POSITION", label: "Pos" },
        { key: "SCORE", label: "Score" },
        { key: "VSPAR", label: "VSPAR" , class: 'RoundsRemove'},
        { key: "ROUNDS", label: "Round", class: 'RoundsRemove' },
        { key: "CURRENCY", label: "Currency", class: 'RoundsRemove' },
        { key: "WINNINGS", label: "Winnings" }
      ]
    };
  }
};
</script>

<style scoped>
::v-deep thead>tr>th{
  text-align: left;
  padding: 8px;
  color: #fff;
  font-size: 13px;
  font-weight: 500;
  border-top: 0px solid #dee2e6!important;
  font-size: 13px;
  text-transform: capitalize;
  padding: 0.75rem;
  padding-left: 5px;
}
::v-deep thead>tr{
  background-color: #2c2c2c!important;
  color: white;
}
::v-deep tbody>tr>td{
  text-align: left;
  padding: 8px;
  /* border-top: 1px solid #fff; */
  font-size: 13px;
  color: #6C6C6C;
}
::v-deep tbody>tr{
  /* background-color: rgba(0,0,0,.05); */
}

::v-deep th:first-child{
  text-align: left;
}
::v-deep td:first-child{
  text-align: left;
  color: #000;
  font-weight: 500;
  font-size: 13px;
}

::v-deep td:last-child{
  color: #3C3C3C;
  font-weight: 700;
}
@media only screen and (max-width: 768px) {
  ::v-deep th.RoundsRemove {
    display: none;
  }
  ::v-deep td.RoundsRemove {
    display: none;
  }
}
</style>
